import "bootstrap/js/dist/tab";

import { bootModules } from "./modules-launcher";

document.addEventListener("DOMContentLoaded", function() {
    bootModules(document);
});
